import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material/app-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FirmwareUpdateComponent } from './components/firmware-update/firmware-update.component';
import { FirmwareConfirmDialogComponent } from './components/firmware-confirm-dialog/firmware-confirm-dialog.component';
import { FirmwareConfigDialogComponent } from './components/firmware-config-dialog/firmware-config-dialog.component';

@NgModule({
  declarations: [FirmwareUpdateComponent, FirmwareConfirmDialogComponent, FirmwareConfigDialogComponent],
  entryComponents: [FirmwareConfirmDialogComponent, FirmwareConfigDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    TranslateModule,
    FlexLayoutModule,
  ],
  exports: [FirmwareUpdateComponent],
})
export class FirmwareUpdateModule {}
